import { Inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { fetch } from '@ngrx/router-store/data-persistence';
import { map } from 'rxjs/operators';
import { CurriculumTreeConceptQueries } from '.';
import {
  CurriculumTreeConceptServiceInterface,
  CURRICULUM_TREE_CONCEPT_SERVICE_TOKEN,
} from '../../curriculum-tree-concept/curriculum-tree-concept.service.interface';
import { DalState } from '../dal.state.interface';
import {
  CurriculumTreeConceptsActionTypes,
  CurriculumTreeConceptsLoaded,
  CurriculumTreeConceptsLoadError,
  LoadCurriculumTreeConcepts,
} from './curriculum-tree-concept.actions';

@Injectable()
export class CurriculumTreeConceptEffects {
  loadCurriculumTreeConcepts$ = createEffect(() =>
    this.actions.pipe(
      ofType(CurriculumTreeConceptsActionTypes.LoadCurriculumTreeConcepts),
      concatLatestFrom(() => this.store.select(CurriculumTreeConceptQueries.getLoaded)),
      fetch({
        run: (action: LoadCurriculumTreeConcepts, loaded: boolean) => {
          if (!action.payload.force && loaded) return;
          return this.curriculumTreeConceptService
            .getAllForUser(action.payload.userId)
            .pipe(map((curriculumTreeConcepts) => new CurriculumTreeConceptsLoaded({ curriculumTreeConcepts })));
        },
        onError: (action: LoadCurriculumTreeConcepts, error) => {
          return new CurriculumTreeConceptsLoadError(error);
        },
      })
    )
  );

  constructor(
    private actions: Actions,
    private store: Store<DalState>,
    @Inject(CURRICULUM_TREE_CONCEPT_SERVICE_TOKEN)
    private curriculumTreeConceptService: CurriculumTreeConceptServiceInterface
  ) {}
}
